import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const quickbase = defineConnector({
  identifier: "quickbase",
  name: "Quickbase",
  tagLine: "Workflow and database platform",
  logo,
  protocol: "http",
  tags: ["data", "productivity"],
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.userToken,
        scheme: "QB-USER-TOKEN",
      },
      {
        name: "QB-Realm-Hostname",
        value: app.config.realmHostname,
      },
    ]),
  steps: [
    {
      title: "Get a Quickbase user token",
      items: [
        {
          kind: "markdown",
          content:
            "In Quickbase, create a user token from your account settings. Quickbase REST requests use the `QB-USER-TOKEN` authorization scheme and the `QB-Realm-Hostname` header.",
        },
      ],
    },
    {
      title: "Enter your Quickbase details",
      items: [
        {
          kind: "input",
          label: "Realm hostname",
          required: true,
          placeholder: "yourrealm.quickbase.com",
          target: { kind: "configuration", field: "realmHostname" },
        },
        {
          kind: "input",
          label: "User token",
          required: true,
          target: { kind: "secrets", field: "userToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.quickbase.com/v1/apps",
  },
  defaultUrlPattern: () => "https://(api\\.)?.*quickbase\\.com/.*",
});
